"use client";
import { SiteContainer } from "@/components/Container";
import { useEffect } from "@/utils/hooks/reactUseCustomHooks";
import { Box } from "@dxp-feed/ui/Box";
import { Button } from "@dxp-feed/ui/Button";
import { notFound } from "next/navigation";

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  if (error.digest === "NEXT_NOT_FOUND") {
    notFound();
  }
  useEffect(() => {
    console.error("An error occurred:", error);
  }, [error]);

  return (
    <SiteContainer>
      <Box as="div" className="flex justify-center items-center flex-col py-8">
        <h1 className="font-bold text-6xl text-brandSecondary">
          Something went wrong!
        </h1>
        <p className="font-normal text-body py-2 text-center">
          {error.message}
        </p>
        <Button
          variant="primary"
          className="mt-2 font-normal !text-body  px-[24px]"
          onClick={() => reset()}
          aria-label="Try again"
        >
          Try Again
        </Button>
      </Box>
    </SiteContainer>
  );
}
